import { ReactElement } from "react"
import { Carousel } from "react-responsive-carousel"
import "react-responsive-carousel/lib/styles/carousel.min.css"
import { pushClickSessionCta } from "../../../../utils/gtm"
import { Wrapper } from "../wrapper/wrapper"
import { BannerProps } from "./banner-props"
import * as S from './banner-style'

export function Banner ({ id, name, ...props }: BannerProps): ReactElement {
  const handleCtaClick = (): void => pushClickSessionCta(name)
  return <S.Container id={id}>
    <Carousel showThumbs={false} showArrows={false} showStatus={false} >
      {props.values.map(banner => <S.BannerContainer>
        <Wrapper>
          <S.BannerWrapper>
            <S.BannerContent>
              <S.Title>{banner.title}</S.Title>
              <S.Description dangerouslySetInnerHTML={{ __html: banner.description }} />
              <S.DesktopLink href={props.urlBuilder.build(banner.button.link, props.params)} onClick={handleCtaClick}>{banner.button.title}</S.DesktopLink>
            </S.BannerContent>
            <img src={banner.image} alt="" />
            <S.MobileLink href={props.urlBuilder.build(banner.button.link, props.params)} onClick={handleCtaClick}>{banner.button.title}</S.MobileLink>
          </S.BannerWrapper>
        </Wrapper>
      </S.BannerContainer>
      )}
    </Carousel>
  </S.Container>
}
